import { lazy } from "react";
import FormLayout from "./Form.layout";
import { Loadable } from "@Elements";

const AppLayout = Loadable(lazy(() => import("./App.layout")));
const AuthLayout = Loadable(lazy(() => import("./Auth.layout")));

export { AppLayout, AuthLayout, FormLayout };
